<template>
  <div>
    <list
      row-key="UserId"
      ref="list"
      unit="数据统计"
      :page="false"
      :query-params="params"
      :show-checkbox="false"
      :show-query="showQuery"
      :get-data-func="api.getStat"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="统计时间">
           <el-date-picker
              v-model="tvalue"
              style="width:300px;"
              type="monthrange"
              align="right"
              unlink-panels
              size="mini"
              :clearable="false"
              range-separator="至"
              value-format="yyyy-MM"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="dateChange"
              :picker-options="pickerOptions">
            </el-date-picker>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="Month" label="月份" min-width="90" />
        <el-table-column prop="CallMinuteCnt" label="通话时长" min-width="90" />
        <el-table-column prop="ConsumptionAmount" label="消费金额（元）" min-width="110" />
        <el-table-column prop="RechargeAmount" label="充值金额（元）" min-width="110" />
        <!-- <el-table-column prop="CreateTime" label="创建时间" min-width="100">
          <template slot-scope="{row}">
            <span>{{$commonJs.toDateString(row.CreateTime)}}</span>
          </template>
        </el-table-column> -->
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
let date = new Date();
let now = date.getFullYear()+"-" + (date.getMonth()+1);
let before = date.getTime() - 3600 * 1000 * 24 * 90;
before = new Date(before);
let before90 = before.getFullYear()+"-" + (before.getMonth()+1);

import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/consume/account").default,
      schoolApi: require("@/api/st/school").default,
      params: {
        StartTime: before90,
        EndTime: now,
      },
      tvalue: [before90,now],
      pickerOptions: {
        shortcuts: [
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近半年',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一年',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit('pick', [start, end]);
            }
          },
        ]
      },
      schoolList: [],
      isMB: this.$store.state.isMB,
    };
  },
  methods: {
    dateChange(e) {
      this.params.StartTime = e[0]
      this.params.EndTime = e[1]
    }
  },
};
</script>